/**
 * Мост обновлений для страницы.
 *
 * Контракт `UpdaterBridge` и его сборка над IPC живут в пакете
 * [`@airelchat/updater`](https://github.com/airelchat/airel-updater); здесь
 * только привязка к этой сборке: `window.airelShell.updater` кладёт preload
 * Electron, а `isDesktop` отвечает, есть ли оболочка вообще.
 *
 * В вебе `window.airelShell` нет — ставим заглушку IPC, но она и не зовётся:
 * машина состояний обходит всё через `supported()`, который там `false`.
 */
import { createUpdaterBridge, type UpdaterIpc } from "@airelchat/updater/renderer";
import { isDesktop } from "@shared/lib/desktop";

export type {
  UpdateTrigger,
  UpdateMetadata,
  NativeUpdateAttempt,
  UpdateBootMode,
  PreparedUpdate,
  UpdateRecoveryStatus,
  InstallProgress,
  UpdaterBridge,
} from "@airelchat/updater/renderer";

const webIpc: UpdaterIpc = {
  currentVersion: async () => import.meta.env.VITE_APP_VERSION ?? "0.0.0",
  check: async () => null,
  download: async () => {},
  restart: async () => {},
};

// `window` читаем осторожно: модуль грузится и в тестах без DOM, а обращение
// к нему на верхнем уровне там упало бы ещё до первого вызова.
const shellIpc = typeof window !== "undefined" ? window.airelShell?.updater : undefined;

export const desktopUpdaterBridge = createUpdaterBridge(shellIpc ?? webIpc, isDesktop);
